import './style.scss';

import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Creatable from 'react-select/creatable';
import { ValueType } from 'react-select';
import { Control, useController } from 'react-hook-form';
import { FieldNameFromControl } from 'app/types/ReactHookFormHelpers';

const listToOptions = (value: string) => ({
  label: value,
  value,
});

type AETitleSelectorProps<ControlledState, Context = any> = {
  // aeTitles: string[];
  control: Control<ControlledState, Context>;
  name: FieldNameFromControl<Control<ControlledState, Context>>;
};

type AETitleOption = {
  label: string;
  value: string;
};

const validateAETitle = (value: string) => {
  // AET Titles should be 16 characters or less and contain only uppercase letters, numbers, and underscores
  return /^[A-Z0-9]{1,16}$/.test(value);
};

const parseChangeValue = (value: ValueType<AETitleOption, true> | null) =>
  value?.map((v) => v.value);

function formatSelectValue(value: string[]) {
  return value?.map(listToOptions);
}

function AETitleSelector<ControlledState, Context = any>({
  control,
  name,
}: AETitleSelectorProps<ControlledState, Context>) {
  const intl = useIntl();
  const { field } = useController({
    control,
    name,
  });
  const { onChange, onBlur, value } = field;

  return (
    <Creatable
      isMulti
      onChange={(value) => onChange(parseChangeValue(value))}
      value={formatSelectValue(value as string[])}
      styles={{
        container: (provided) => ({ ...provided, width: '100%' }),
        control: (provided) => ({
          ...provided,
          borderRadius: '0 4px 4px 0',
          borderLeft: 'none',
          borderColor: 'hsl(0, 0%, 80%)',
        }),
      }}
      onBlur={onBlur}
      components={{ DropdownIndicator: null, IndicatorSeparator: null }}
      isValidNewOption={validateAETitle}
      placeholder={<FormattedMessage id="pacs.configuration.worklist.aetitle.placeholder" />}
      formatCreateLabel={(inputValue) => (
        <FormattedMessage
          id="pacs.configuration.worklist.aetitle.add_filter"
          values={{ value: inputValue }}
        />
      )}
      noOptionsMessage={({ inputValue }) => {
        if (!inputValue || inputValue.length === 0) {
          return intl.formatMessage({ id: 'pacs.configuration.worklist.aetitle.no_options' });
        }
        return intl.formatMessage({ id: 'pacs.configuration.worklist.aetitle.bad_option' });
      }}
    />
  );
}

export default AETitleSelector;
